//export const SENSZ_AI_BO_BASE_URL = `http://sensz.pixvisonz.com:8094/api/v1`;

//export const SENSZ_AI_WM_BASE_URL = `http://api-wms.sensz.ai:8095/api/v1`;

export const SENSZ_AI_BO_BASE_URL = `https://ctm.sensz.ai/bo`;

export const SENSZ_AI_CLIENT_BASE_URL = `https://ctm.sensz.ai/wms`;

//export const baseURL = `http://api-wms.sensz.ai:8095/api/v1`;

export const CTM_BASE_URL = `https://api.pixvisonz.com/v1`;

export const googleMapsConfig = {
  apiKey: "AIzaSyBieos3XOdthBCASzsAvKOvdg8XD5BvD_k", // Replace with your Google Maps API key
};

export const CtmUrlConfigs = {
  MAP_STYLE_URL: "mapbox://styles/mapbox/streets-v11",
  MAPBOX_ACCESS_TOKEN:
    "pk.eyJ1Ijoic3JpbmF0aHJhamEiLCJhIjoiY2xoNXR2NGp2MGJzMDNlczg5ZDA5ZTNwdSJ9.VPL2vn4eXArjXHpPz9RYQg",
  API_URL: "https://api.pixvisonz.com/v1/",
};
